import { FormattedMessage } from 'react-intl';
import { To } from 'react-router-dom';
import styled from 'styled-components';

import { Link } from '@sorare/routing';

import { Button } from '@sorare/core/src/atoms/buttons/Button';
import { Vertical } from '@sorare/core/src/atoms/layout/flex';
import { LabelL } from '@sorare/core/src/atoms/typography';
import { navLabels } from '@sorare/core/src/lib/glossary';
import { tabletAndAbove } from '@sorare/core/src/style/mediaQuery';

const Root = styled(Vertical).attrs({ center: true })`
  position: relative;
  width: 100%;
  height: 260px;
  border: 1px solid var(--c-nd-150);
  border-radius: var(--double-unit);

  @media ${tabletAndAbove} {
    width: 340px;
  }
`;

type Props = { to: To; onClick?: () => void };
export const MyClubNavItem = ({ to, onClick }: Props) => {
  return (
    <Root as={Link} to={to} onClick={onClick}>
      <Button color="quaternary" size="medium">
        <LabelL bold>
          <FormattedMessage {...navLabels.myClub} />
        </LabelL>
      </Button>
    </Root>
  );
};
